const Styles = () => ({
  card: {
    background: "transparent",
    border: "solid white"
  },
  media: {
    height: 350,
  },
  titleText: {
    color: "white",
    fontSize: "24px",
  },
  subtitleText: {
    color: "white",
    fontSize: "14px",
  },
  mediaRoot: {
    minHeight: "400px"
  },
  focusHighlight: {
    borderRadius: "none",
  }
});

export default Styles;
